import React, { useState } from "react";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import HeaderCardBody from "../../app/HeaderCardBody";
import { MdArrowForwardIos, MdClose, MdHeadsetMic } from "react-icons/md";
import PropTypes from "prop-types";

import "./Chat.css";
import useBreakpoint from "../../Utils/useBreakpoint";
import { Input } from "semantic-ui-react";
const chats = [
  {
    id: 1,
    atendimentoId: "#123",
    dataUltimaMensagem: new Date(),
    status: "em-atendimento",
    mensagens: [
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "enviada",
        mensagem: "Esse é um teste de mensagem enviada para aparecer que seja minimamente grande",
      },
      {
        tipo: "recebida",
        mensagem: "Esse é um teste de mensagem recebida para aparecer que seja minimamente grande",
      },
      {
        tipo: "recebida",
        mensagem: "Esse é um teste de mensagem recebida para aparecer que seja minimamente grande",
      },
      {
        tipo: "recebida",
        mensagem: "Esse é um teste de mensagem recebida para aparecer que seja minimamente grande",
      },
      {
        tipo: "enviada",
        mensagem: "Esse é um teste de mensagem enviada para aparecer que seja minimamente grande",
      },
      {
        tipo: "enviada",
        mensagem: "Esse é um teste de mensagem enviada para aparecer que seja minimamente grande",
      },
      {
        tipo: "enviada",
        mensagem: "Esse é um teste de mensagem enviada para aparecer que seja minimamente grande",
      },
    ],
  },
  {
    id: 2,
    atendimentoId: "#321",
    dataUltimaMensagem: new Date(),
    status: "em-atendimento",
    mensagens: [
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
    ],
  },
  {
    id: 3,
    atendimentoId: "#445",
    dataUltimaMensagem: new Date(),
    status: "encerrado",
    mensagens: [
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
    ],
  },
  {
    id: 4,
    atendimentoId: "#445",
    dataUltimaMensagem: new Date(),
    status: "encerrado",
    mensagens: [
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
    ],
  },
  {
    id: 5,
    atendimentoId: "#445",
    dataUltimaMensagem: new Date(),
    status: "encerrado",
    mensagens: [
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
    ],
  },
  {
    id: 6,
    atendimentoId: "#445",
    dataUltimaMensagem: new Date(),
    status: "encerrado",
    mensagens: [
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "enviada",
        mensagem: "Olá, tudo bem?",
      },
      {
        tipo: "recebida",
        mensagem: "Olá, tudo bem?",
      },
    ],
  },
];

function Chat() {
  const [open, setOpenChat] = useState(false);
  const [activeChat, setActiveChat] = useState(null);
  const mediaSize = useBreakpoint();
  const openChat = (chat) => {
    setOpenChat(true);
    setActiveChat(chat);
  };

  const handleEnviaMensagem = (msg) => {
    console.log(msg);
  };

  return (
    <Card>
      <HeaderCardBody titulo="Chat" mostraBotao={false} />
      <CardBody className="pb-5">
        <Row>
          {(mediaSize === "sm" || mediaSize === "xs") && open ? null : (
            <Col md={4} sm={12} className="overflow-auto chat-component-container">
              {chats.map((chat) => (
                <ChatComponent chat={chat} key={chat.id} openChat={openChat} />
              ))}
            </Col>
          )}
          {(mediaSize === "sm" || mediaSize === "xs") && !open ? null : activeChat && open ? (
            <Col md={8} sm={12} className="chat-screen-container">
              <ChatScreen chat={activeChat} setOpen={setOpenChat} enviaMensagem={handleEnviaMensagem} />
            </Col>
          ) : null}
        </Row>
      </CardBody>
    </Card>
  );
}

function ChatComponent({ chat, openChat }) {
  return (
    <section className="chat-component" onClick={() => openChat(chat)}>
      <Row>
        <Col md={3} xs={3}>
          <div className="chat-component-avatar">
            <MdHeadsetMic color="#2b4faa" className="avatar-icon" />
          </div>
        </Col>
        <Col md={9} xs={9} className="chat-component-descricao">
          <div className="chat-component-titulo">{chat.atendimentoId}</div>
          <div className="ultima-mensagem">{chat.mensagens[0].mensagem}</div>
          <Badge className={`status-atendimento ${chat.status === "encerrado" ? "encerrado" : "em-atendimento"}`}>
            {chat.status === "encerrado" ? "Encerrado" : "Em atendimento"}
          </Badge>
        </Col>
      </Row>
    </section>
  );
}

function ChatScreen({ chat, setOpen, enviaMensagem }) {
  const [mensagem, setMensagem] = useState("");
  return (
    <section className="chat-screen">
      <div className="chat-screen-topbar">
        <div className="chat-screen-avatar">
          <MdHeadsetMic color="#2b4faa" className="avatar-icon" />
        </div>
        <span className="chat-screen-titulo">Chat {chat.atendimentoId}</span>
        <MdClose className="close-icon" onClick={() => setOpen(false)} />
      </div>
      <div className="chat-screen-chat overflow-auto">
        {chat.mensagens.map((mensagem, index) => {
          if (mensagem.tipo === "enviada") {
            return (
              <div className="mensagem-enviada-container" key={index}>
                <div className="mensagem-enviada">
                  <span>{mensagem.mensagem}</span>
                </div>
                <div className="chat-screen-avatar">
                  <MdHeadsetMic color="#2b4faa" className="avatar-icon" />
                </div>
              </div>
            );
          } else
            return (
              <div className="mensagem-recebida-container" key={index}>
                <div className="chat-screen-avatar">
                  <MdHeadsetMic color="#2b4faa" className="avatar-icon" />
                </div>
                <div className="mensagem-recebida">
                  <span>{mensagem.mensagem}</span>
                </div>
              </div>
            );
        })}
      </div>
      <div className="chat-screen-input-container">
        <Input className="chat-screen-input-mensagem" icon placeholder="Digite sua mensagem...">
          <input
            value={mensagem}
            onChange={(e) => setMensagem(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                enviaMensagem(mensagem);
              }
            }}
          />
          <div className="chat-screen-input-icon-container" onClick={() => enviaMensagem(mensagem)}>
            <MdArrowForwardIos />
          </div>
        </Input>
      </div>
    </section>
  );
}

ChatComponent.propTypes = {
  chat: PropTypes.shape({
    id: PropTypes.number,
    atendimentoId: PropTypes.string,
    status: PropTypes.oneOf(["em-atendimento", "encerrado"]),
    mensagens: PropTypes.array,
    dataUltimaMensagem: PropTypes.instanceOf(Date),
  }).isRequired,
  openChat: PropTypes.func.isRequired,
};
ChatScreen.propTypes = {
  chat: PropTypes.shape({
    id: PropTypes.number,
    atendimentoId: PropTypes.string,
    status: PropTypes.oneOf(["em-atendimento", "encerrado"]),
    mensagens: PropTypes.array,
    dataUltimaMensagem: PropTypes.instanceOf(Date),
  }).isRequired,
};

export default Chat;
